<template>
  <div class="product container_box">
    <div class="product_header">
      <h1>数据赋能应用，创造数字未来</h1>
    </div>
    <div class="product_list w_1200 m_auto">
      <div class="cont_list flex">
        <div class="product_list_box">
          <h3>职业技能培训</h3>
          <ul  >
            <li >
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
          </ul>
        </div>
        <div class="product_list_box">
          <h3>智慧工会建设</h3>
          <ul @click="$router.push('/productDetail')">
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
          </ul>
        </div>
        <div class="product_list_box">
          <h3>媒体运营服务</h3>
          <ul @click="$router.push('/productDetail')">
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
            <li>
              <span class="icon"></span>
              <span class="text">高技能人才素质提升平台——中工云课堂</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 中工云课堂 -->
    <div class="zgykt_box">
      <p class="title_head">中工云课堂</p>
      <p class="btn cursor" @click="goPrDetail()">点击查看</p>
      <div class="swiper_box">
        <!-- <img src="@/assets/pc/product/img1.png" alt="" /> -->
        <swiper ref="mySwiper" class="banner" :options="bannerOption">
            <swiper-slide class="slide">
              <div class="bgm_img">
                <img src="@/assets/pc/product/img1.png" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide class="slide">
              <div class="bgm_img">
                <img src="@/assets/pc/product/img1.png" alt="" />
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev swiper-button-prevsp" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-nextsp" slot="button-next"></div>
       
          </swiper>
      </div>
    </div>

    <!-- 产品动态 -->
    <div class="cpdt_box w_1200 m_auto">
      <p class="title">产品动态</p>
      <p class="tips">中工科创产品最新走向</p>
      <div class="cont_box">
        <div class="left_img">
          <img src="@/assets/pc/product/left_img.png" alt="" />
          <div class="img_cont">
            <p class="text">荟投票·云上会议投票系统3.0版本发布</p>
            <p class="btn flex">
              <span class="cursor">了解更多</span>
              <!-- <img src="" alt=""> -->
            </p>
          </div>
        </div>
        <div class="right_list">
          <ul>
            <li @click="goNewsDetail()">荟投票·云上会议投票系统3.0版本发布</li>
            <li>大师来了是如何走入企业内部的</li>
            <li>元宇宙+VR+教育，打开职业技能培训新篇章</li>
            <li>户外劳动者站点IOT发展模式</li>
            <li>劳模管理系统2.0版本再起航</li>
            <li>数据交叉分析与数据可视化</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data(){
    return{
      bannerOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // loop: true, //循环
        autoplay: {
          delay: 5000,
          // stopOnLastSlide: false,
          // disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    }
  },
  methods:{
    goPrDetail(){
      this.$router.push('/productDetail')
    },
    goNewsDetail(){
      this.$router.push('/newsDetail')
    },
  }
};
</script>

<style lang="scss" scoped>
.product {
  /* 头部 */
  margin-top: -84px;
  .product_header {
    width: 100%;
    background: url(@/assets/pc/product/bgm.png) 0 0 no-repeat;
    background-size: cover;
    text-align: center;
    h1 {
      padding-top: 307px;
      padding-bottom: 364px;
      font-size: 50px;
      color: #fff;
    }
  }
  /* 详情 */
  .product_list {
    margin-top: -141px;
    background: #fff;
    .product_list_box {
      flex: 1;
      padding: 43px 33px 50px 33px;
      border-right: 1px solid #ededec;
      box-shadow: 0px 15px 20px 1px rgba(62,105,116,0.1);
      h3 {
        font-size: 26px;
        color: #316cff;
      }
      ul {
        margin-top: 24px;
        li {
          color: #333333;
          font-size: 16px;
          position: relative;
          display: flex;
          align-items: flex-start;
          margin-bottom: 18px;
          span.icon {
            display: block;
            width: 3px;
            height: 3px;
            border-radius: 3px;
            background: #333;
            margin-top: 5px;
          }
          span.text {
            display: block;
            flex: 1;
            margin-left: 10px;
          }
        }
      }
    }
  }

  .zgykt_box {
    background: url("@/assets/pc/product/bgm1.png") no-repeat;
    background-size: 100% 900px;
    height: 945px;
    box-sizing: border-box;
    margin-top: 110px;
    p.title_head {
      text-align: center;
      font-size: 40px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      padding-top: 121px;
    }
    p.btn {
      width: 165px;
      height: 56px;
      background: linear-gradient(90deg, #1eaffc 0%, #24d8e5 99%, #24d8e5 100%);
      border-radius: 6px 6px 6px 6px;
      text-align: center;
      line-height: 56px;
      color: #fff;
      font-size: 18px;
      margin: 39px auto 0;

    }
    .swiper_box{
      width: 1200px;
      margin: 35px auto 0;
      img{
        width: 100%;
      }
    }
  }

  // 产品动态
  .cpdt_box{
    margin-top: 110px;
    p.title{
      font-size: 40px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #316CFF;
      line-height: 102px
    }
    p.tips{
      margin-top: 21px;
      font-size: 18px;
      color: #333333;
    }
    .cont_box{
      display: flex;
      margin-top: 56px;
      .left_img{
        position: relative;
        img{
          width: 448px;
          height: 290px;
        }
        .img_cont{
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 104px;
          background: rgba(63,88,139,.5);
          box-sizing: border-box;
          p.text{
            padding: 40px 20px 18px 20px;
            font-size: 24px;
            color: #FFFFFF;
          }
          p.btn{
            margin-left: 20px;
            span{
              font-size: 14px;
              color: #03E5C4;
            }
          }
        }
      }
      .right_list{
        margin-left: 25px;
        flex: 1;
        ul{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li{
            cursor: pointer;
            width: 354px;
              height: 84px;
              background: #FFFFFF;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
              border: 1px solid #EDEDEC;
              color: #333;
              font-size: 18px;
              display: flex;
              align-items: center;
              margin-bottom: 20px;
              box-sizing: border-box;
              padding: 0 25px;
          }
        }
      }
    }
  } 
}
// 轮播图箭头样式更改
.swiper-button-prev, .swiper-button-next{
  width: 36px;
  height: 36px;
}
.swiper-button-prev::after, .swiper-button-next::after{
  content: '';
}
.swiper-button-prev{
  background: url('@/assets/pc/index/arrow_left.png') no-repeat;
  background-size: 100% 100%;
}
.swiper-button-next{
   background: url('@/assets/pc/index/arrow_right.png') no-repeat;
   background-size: 100% 100%;
}
.swiper-button-prev.swiper-button-disabled{
  background: url('@/assets/pc/index/arrow_left1.png') no-repeat;
  background-size: 100% 100%;
  opacity: 1;
}
.swiper-button-next.swiper-button-disabled{
   background: url('@/assets/pc/index/arrow_right1.png') no-repeat;
   background-size: 100% 100%;
   opacity: 1;
}

.swiper_box::v-deep .swiper-pagination-bullet {
  display: inline-block;
  width: 9px;
  height: 9px;
  background: #316CFF;
  margin: 0 3px;
  // display: flex;
  // justify-content: flex-end;
}
.swiper_box::v-deep .swiper-pagination-bullets {
  display: flex;
  justify-content: center;
  padding-right: 37px;
}

.swiper_box::v-deep .swiper-pagination-bullet-active {
  width: 52px;
height: 9px;
background: #316CFF;
border-radius: 10px 10px 10px 10px;
  // opacity: 1;
}
</style>